const GradientText = ({ children }: { children: React.ReactNode }) => {
  return (
    <span
      style={{
        background:
          "linear-gradient(101deg, #0A4145 -3.56%, #3E986C 36.5%, #A7B542 70.07%, #E1A602 104.71%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      {children}
    </span>
  );
};

export default GradientText;
